export default __webpack_public_path__ + "static/media/damodra-temple.9b63bcd6.png";